import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M13 18.004h-6.343c-2.572 -.004 -4.657 -2.011 -4.657 -4.487c0 -2.475 2.085 -4.482 4.657 -4.482c.393 -1.762 1.794 -3.2 3.675 -3.773c1.88 -.572 3.956 -.193 5.444 1c1.488 1.19 2.162 3.007 1.77 4.769h.99c1.37 0 2.556 .8 3.117 1.964","key":"svg-0"}],["path",{"d":"M22 22l-5 -5","key":"svg-1"}],["path",{"d":"M17 22l5 -5","key":"svg-2"}]]

const IconCloudX = createReactComponent('outline', 'cloud-x', 'CloudX', __iconNode);

export default IconCloudX;